import {
	Instance,
	types,
	flow,
	applySnapshot,
	getParent,
} from 'mobx-state-tree';
import { deleteGoal, saveGoal } from '@common/api/goals';
import { postSteps } from '@common/api/goalsSteps';

import Step from './Step';

const Goal = types
	.model('Goal', {
		id: types.identifierNumber,
		student_id: types.number,
		title: types.optional(types.string, ''),
		steps: types.optional(types.array(Step), []),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({}))
	.actions((self) => ({
		remove: flow(function* () {
			self.loading = true;
			try {
				yield deleteGoal(self.id);
				const parent: any = getParent(self, 2);
				parent.removeGoal(self);
			} catch (e) {
				self.loading = false;
			}
		}),
		save: flow(function* (data: any) {
			self.loading = true;
			try {
				const result = yield postSteps(data);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		createSteps: flow(function* (data: any) {
			self.loading = true;
			try {
				const result = yield saveGoal(self.id, data);
				applySnapshot(self.steps, result);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default Goal;

export interface IGoalModel extends Instance<typeof Goal> {}
